import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { modalAnimation } from '../../../shared/design-system/organisms/p-modal/p-modal.animation';
import { ModalService } from '../../../shared/design-system/organisms/p-modal/p-modal.service';
import { ErrorState, ErrorStateService } from '../../state/error-state.service';
import { DesignSystemModule } from '../../../shared/design-system/design-system.module';
import { CommonModule } from '@angular/common';
import { PButtonComponent } from '../../../shared/design-system/atoms/p-button/p-button.component';
import { PInputComponent } from '../../../shared/design-system/atoms/p-input/p-input.component';

@Component({
  selector: 'app-section',
  templateUrl: './section.component.html',
  styleUrls: ['./section.component.scss'],
  animations: [modalAnimation],
  imports: [
    DesignSystemModule,
    CommonModule,
    PButtonComponent,
    PInputComponent,
  ],
  standalone: true,
})
export class SectionComponent implements OnInit, OnDestroy, OnChanges {
  @Input() titleSection!: string;
  @Input() isLargeTitle = false;
  @Input() isActivated!: boolean;
  @Input() onlyTitle = false;
  @Input() hiddenTitle = false;
  @Input() isEditable = true;
  @Input() isActivable = true;
  @Input() isInputDisabled = false;
  @Input() isCancable = true;

  @Output() enabled = new EventEmitter<boolean>();
  @Output() saved = new EventEmitter<void>();
  @Output() cancled = new EventEmitter<void>();

  isModalEditVisible = false;
  modalId!: string;
  error!: ErrorState;

  private readonly destroy$ = new Subject<void>();

  constructor(
    private readonly modalService: ModalService,
    private readonly errorStateService: ErrorStateService,
  ) {}

  ngOnChanges(): void {
    // Chaque modale doit avoir un identifiant unique
    // On le génère à partir du titre de la section
    this.modalId = `${this.titleSection.replace(/\s+/g, '_')}_id`;
  }

  ngOnInit(): void {
    this.errorStateService.errorState$
      .pipe(takeUntil(this.destroy$))
      .subscribe((errorState) => {
        this.error = errorState;
      });

    this.modalService
      .getModalState()
      .pipe(takeUntil(this.destroy$))
      .subscribe((modalId) => {
        this.isModalEditVisible = modalId === this.modalId;
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  openEditPanel() {
    this.errorStateService.clearError();
    this.modalService.showModal(this.modalId);
  }

  closeEditPanel() {
    this.errorStateService.clearError();
    this.modalService.hideModal();
    this.cancled.emit();
  }

  onEnabledSectionSwitched(event: boolean) {
    this.enabled.emit(event);
  }
}
